import { Wording } from '@/types';

export const LOVE_WORDING_BG: Wording = {
  components_header_media_content: 'Aудиозаписи',
  components_header_media_1: 'Медитации',
  components_header_media_2: 'Подкаст',
  components_header_text1: 'Ръководства',
  components_header_text2: 'Блог',
  components_header_members: 'Членове',
  hero_text: 'Открийте любовта през звездите',
  hero_button_text: 'Започнете вашето пътуване',
  components_ressources_section_title: 'ЛЮБОВ И АСТРОЛОГИЯ',
  components_ressources_subheader_text: 'Вашият небесен набор от инструменти за романтично прозрение',
  components_ressources_span_text: 'Потопете се в нашата вселена от подкасти и статии, фокусирани върху любовта, зодиакалната съвместимост и космическата връзка. Независимо дали търсите яснота за сродната душа или декодирате моделите на връзката си, нашите ресурси ви насочват към по-дълбоко разбиране чрез звездите.',
  components_ressources_card_1_title: 'Любовни разговори на зодиака',
  components_ressources_card_1_text: 'Разгледайте прочувствени подкаст епизоди, задълбочаващи се в емоционалния език на всеки знак, любовна съвместимост, страст и личностно израстване в отношенията.',
  components_ressources_card_2_title: 'Любовен блог',
  components_ressources_card_2_text: 'Прочетете прозрения и размисли за това как всеки знак обича, лекува и свързва. От синастрията до планетарната романтика, нашият блог е вашето ръководство за астрологична любов.',
  components_ressources_link: 'Разгледайте допълнително',
  components_notes_and_google_title_1: 'Романтична астрология',
  components_notes_and_google_title_2: 'Любовни навици',
  components_notes_and_google_title_3: 'Любовни отражения на слушателите',
  components_review_google_text: 'Какво казват нашите слушатели',
  media_content_section_title: 'ПОДКАСТ ЛЮБОВ И ЗОДИЯ',
  media_content_section_subheader_text: 'Истински разговор за космическата романтика',
  text_media_1: 'Настройте се на дълбоки, разкриващи епизоди за астрологични съвпадения, емоционални модели и романтична динамика.',
  text_media_2: '',
  media_content_section_button_more: 'Слушай сега',
  text2_section_title: 'БЛОГ',
  text2_section_subheader_text: 'Астрологични любовни истории и прозрения',
  text2_section_button_more: 'Зареди още',
  components_text1_section_title: 'РЪКОВОДСТВА',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Оставете звездите да ръководят вашата любовна история',
  components_footer_info: 'Информация',
  components_footer_registration_number: 'Регистрационен номер',
  components_footer_legal: 'Законни',
  components_footer_terms: 'Правила и условия',
  components_footer_privacy: 'Политика за поверителност',
  button_load_more: 'Зареди още',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Любов и зодиак: Подкаст епизоди',
  page_media_content_menu_compatibility: 'Съвместимост',
  page_media_content_menu_love: 'любов',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Изследвайте любовта чрез астрологията',
  page_text2_section_title: 'Блог',
  page_text2_subheader_text: 'Статии',
  enter_email_title: 'Моля, въведете вашия имейл, за да продължите',
  enter_email_placeholder_email: 'Имейл',
  enter_email_button_enter: 'Въведете',
  components_login_success_text: 'Успешно влизане!',
  components_card_link_media_content: 'Слушай сега',
  components_card_link_text2_content: 'Прочетете статии',
  components_card_link_text1_content: '',
  france: 'Франция',
  cyprus: 'Кипър',
  tag_podcast: 'Подкаст',
  tag_meditation: 'Медитация',
  page_media_content_menu_all: 'Всички',
};